import { formatTicketDate } from '../../../../../utils/supportHelpers';
import StatusBadge from './StatusBadge';

const TicketListItem = ({ ticket, isSelected, onSelect }) => {
  return (
    <button
      onClick={() => onSelect(ticket._id)}
      className={`w-full p-4 flex flex-col gap-1 text-left transition-all cursor-pointer ${
        isSelected
          ? 'bg-[#067978]/5 border-l-4 border-l-[#067978]'
          : 'hover:bg-gray-50'
      }`}
    >
      <div className="flex justify-between items-center">
        <span className="text-[9px] font-bold text-gray-400 font-mono">
          #{ticket._id ? ticket._id.slice(-6).toUpperCase() : ''}
        </span>
        <StatusBadge status={ticket.status} />
      </div>

      <p
        className={`text-sm font-bold truncate mt-1 ${
          isSelected ? 'text-[#067978]' : 'text-gray-900'
        }`}
      >
        {ticket.issue_description}
      </p>

      <div className="flex justify-between items-end mt-1">
        <p className="text-[11px] text-gray-400 truncate flex-1 font-medium mr-2">
          {ticket.messages && ticket.messages.length > 0
            ? ticket.messages[ticket.messages.length - 1].message
            : 'No messages yet'}
        </p>
        <span className="text-[9px] text-gray-300 font-bold whitespace-nowrap">
          {formatTicketDate(ticket.createdAt)}
        </span>
      </div>
    </button>
  );
};

export default TicketListItem;
